export default __webpack_public_path__ + "static/media/gallery5.332b3f1f.jpg";